<template>
  <NoteWithIcon v-if="isEnabled" class="location-review-callout" color="gray" size="small">
    <template #text>
      <strong class="location-review-callout__title">{{ source === "dashboard" ? "Help local businesses get seen" : "Include more places to promote" }}</strong>
      <p class="location-review-callout__copy">We found businesses and events for your destination.</p>
      <SrpButton color="teal" size="small" :to="{ name: 'AtlasOnboardingLocations', params: { customerId } }" @click="trackClick"> Review new locations </SrpButton>
    </template>
  </NoteWithIcon>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import FeatureFlagRepo, { ONBOARDED_BUT_NEEDS_LOC_REVIEW } from "@logic/FeatureFlagRepo";
import { getGlobalRemoteLogger } from "@/helpers/RemoteLogger";
import { MetricSender } from "@/helpers/MetricSender";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import SrpButton from "@components/ui/SrpButton.vue";

const props = defineProps<{ customerId: string; source: "dashboard" | "localPromotion" }>();
const emit = defineEmits<{ visibilityChange: [visible: boolean] }>();
const isEnabled = ref(false);

watch(
  () => props.customerId,
  async customerId => {
    isEnabled.value = false;
    emit("visibilityChange", false);
    if (!customerId) return;
    try {
      const enabled = await FeatureFlagRepo.getCustomerFlag(customerId, ONBOARDED_BUT_NEEDS_LOC_REVIEW);
      if (props.customerId !== customerId) return;
      isEnabled.value = enabled;
      emit("visibilityChange", enabled);
    } catch (error) {
      getGlobalRemoteLogger()?.error(`LocationReviewCallout failed. customerId=${customerId} error=${error}`);
    }
  },
  { immediate: true }
);

function trackClick() {
  MetricSender.sendMetric("Cust-LocationReview-CTA", { customerId: props.customerId, source: props.source });
}
</script>

<style scoped lang="scss">
.location-review-callout {
  margin: 18px 0;
  background: #eef8f7;
  border-color: #cce3e1;
  border-left-color: #118689;

  :deep(.note-with-icon__icon .embedded-icon svg) {
    fill: #118689;
  }

  &__title {
    display: block;
  }
  &__copy {
    margin: 5px 0 12px;
  }
}
</style>
